import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RequestConfirmDialog, type ConfirmOptions, type ConfirmService } from '../confirm-service';
import { createDialog } from '@patsnap/tahiti-core';

/**
 * Vue3 确认对话框服务
 */
@injectable()
export class VueConfirmService implements ConfirmService {
    constructor(
        @inject(RequestConfirmDialog)
        private _confirmDialog: RequestConfirmDialog,
    ) {}

    confirm(message: string, options?: ConfirmOptions): Promise<boolean> {
        return this._confirmDialog.open({ message, ...options });
    }
}

/**
 * 创建请求确认对话框
 * @returns 请求确认对话框工厂
 */
export function createRequestConfirmDialog() {
    return createDialog(() => import('./ConfirmDialog.vue'));
}
